module.exports = __webpack_public_path__ + "public/images/speaker-photo-1.a9fa4e856f2455b7b3217b05f6bf739b.png";